import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaQuestionCircle, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import styles from './ProductQuestionAnswers.module.css';

const ProductQuestionAnswers = () => {
    const [expandedQuestion, setExpandedQuestion] = useState(null);

    const questions = [
        {
            id: 1,
            question: 'What is the size of this bed, double or single?',
            answer: 'Double',
            author: 'Mani Kumar Makam',
            upvotes: 7625,
        },
        {
            id: 2,
            question: 'Top surface if any dirty or dust, how should I clean it? What should or shouldn’t I use?',
            answer: 'IP or thinner can be used for cleaning.',
            author: 'Anurag Anant',
            upvotes: 388219,
        },
        {
            id: 3,
            question: 'Is there storage space inside?',
            answer: 'No',
            author: 'Anonymous',
            upvotes: 7036,
        },
    ];

    const toggleQuestion = (id) => {
        setExpandedQuestion((prev) => (prev === id ? null : id));
    };

    return (
        <div className={styles.container}>
            <h2 className={styles.heading}>
                <FaQuestionCircle className={styles.icon} /> Questions and Answers
            </h2>
            <ul className={styles.questionList}>
                {questions.map(({ id, question, answer, author, upvotes }) => (
                    <li key={id} className={styles.questionItem}>
                        <div
                            className={styles.questionHeader}
                            onClick={() => toggleQuestion(id)}
                        >
                            <p className={styles.questionText}>{question}</p>
                            <span className={styles.toggleIcon}>
                                {expandedQuestion === id ? <FaChevronUp /> : <FaChevronDown />}
                            </span>
                        </div>
                        <AnimatePresence>
                            {expandedQuestion === id && (
                                <motion.div
                                    className={styles.answerSection}
                                    initial={{ opacity: 0, height: 0 }}
                                    animate={{ opacity: 1, height: 'auto' }}
                                    exit={{ opacity: 0, height: 0 }}
                                    transition={{ duration: 0.3 }}
                                >
                                    <p className={styles.answerText}>{answer}</p>
                                    <p className={styles.authorInfo}>
                                        - {author} <span className={styles.upvotes}>{upvotes} upvotes</span>
                                    </p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </li>
                ))}
            </ul>
            <button className={styles.readMoreButton}>Read other answers</button>
            <button className={styles.allQuestionsButton}>All questions</button>
        </div>
    );
};

export default ProductQuestionAnswers;
